// extracted by mini-css-extract-plugin
export default {"filtersContainer":"user-filters_filtersContainer__duFuR","dropdownContainer":"user-filters_dropdownContainer__jDPAM","marginRight10":"user-filters_marginRight10__1oo4X"};